/*
  HALO Globo: globo 3D da seção HALO Presença Global.
  WebGL puro, sem bibliotecas. Um único triângulo cobre o canvas e o shader converte
  cada pixel da esfera em latitude e longitude para ler o mapa equirretangular.
  Matrizes 3x3 em ordem de linha. M leva um ponto da vista (x direita, y cima, z para fora
  da tela) para o globo (y = polo norte, z = longitude 0).
*/
(function () {
  'use strict';

  if (!window.customElements || customElements.get('halo-globo')) return;

  var DEG = Math.PI / 180;
  var RADIUS = 0.9; // raio da esfera no canvas; o restante é o brilho externo
  var GLOW = 0.08; // largura do brilho externo, em raios
  var MAX_FLICK = 1.2; // velocidade máxima da inércia, em px/ms

  var VERT =
    'attribute vec2 a_pos;varying vec2 v_pos;' +
    'void main(){v_pos=a_pos;gl_Position=vec4(a_pos,0.0,1.0);}';

  function fragSource(deriv) {
    return (
      (deriv ? '#extension GL_OES_standard_derivatives : enable\n#define HALO_DERIV 1\n' : '') +
      [
        '#ifdef GL_FRAGMENT_PRECISION_HIGH',
        'precision highp float;',
        '#else',
        'precision mediump float;',
        '#endif',
        'varying vec2 v_pos;',
        'uniform sampler2D u_tex;',
        'uniform mat3 u_rot;',
        'uniform float u_radius;',
        'uniform float u_aa;',
        'uniform float u_glow;',
        'uniform vec3 u_rim;',
        'uniform float u_rimStrength;',
        'uniform float u_exposure;',
        'const float PI = 3.14159265;',
        'void main() {',
        '  vec2 p = v_pos / u_radius;',
        '  float d2 = dot(p, p);',
        '  float d = sqrt(d2);',
        '  vec3 n = vec3(p, sqrt(max(1.0 - d2, 0.0)));',
        '  vec3 g = u_rot * n;',
        '  float lat = asin(clamp(g.y, -1.0, 1.0));',
        '  float lon = atan(g.x, g.z);',
        '  vec2 uvA = vec2(lon / (2.0 * PI) + 0.5, 0.5 - lat / PI);',
        // Na costura de longitude 180 a coordenada salta de 1 para 0; a versão deslocada
        // evita a linha que o mipmap desenharia ali.
        '  vec2 uvB = vec2(fract(uvA.x + 0.5) - 0.5, uvA.y);',
        '#ifdef HALO_DERIV',
        '  vec2 uv = fwidth(uvA.x) <= fwidth(uvB.x) + 0.000001 ? uvA : uvB;',
        '#else',
        '  vec2 uv = uvA;',
        '#endif',
        '  vec3 tex = texture2D(u_tex, uv).rgb;',
        '  float diff = max(dot(n, normalize(vec3(-0.45, 0.55, 0.7))), 0.0);',
        '  float fres = pow(1.0 - n.z, 2.5);',
        '  vec3 col = min(tex * u_exposure * (0.55 + 0.6 * diff) + u_rim * fres * u_rimStrength, vec3(1.0));',
        '  float sphereA = 1.0 - smoothstep(1.0 - u_aa, 1.0, d);',
        '  float glowA = pow(1.0 - smoothstep(1.0, 1.0 + u_glow, d), 2.0) * u_rimStrength * 0.5;',
        '  float a = sphereA + glowA * (1.0 - sphereA);',
        '  gl_FragColor = vec4(col * sphereA + u_rim * glowA * (1.0 - sphereA), a);',
        '}',
      ].join('\n')
    );
  }

  function mul(a, b) {
    var r = new Array(9);
    for (var i = 0; i < 3; i++) {
      for (var j = 0; j < 3; j++) {
        r[i * 3 + j] = a[i * 3] * b[j] + a[i * 3 + 1] * b[3 + j] + a[i * 3 + 2] * b[6 + j];
      }
    }
    return r;
  }

  function rotX(t) {
    var c = Math.cos(t);
    var s = Math.sin(t);
    return [1, 0, 0, 0, c, -s, 0, s, c];
  }

  function rotY(t) {
    var c = Math.cos(t);
    var s = Math.sin(t);
    return [c, 0, s, 0, 1, 0, -s, 0, c];
  }

  // Orientação que coloca (lat, lon) no centro, com o norte para cima.
  function orient(lat, lon) {
    return mul(rotY(lon * DEG), rotX(-lat * DEG));
  }

  // Corrige o acúmulo de erro numérico depois de muitas rotações.
  function orthonormalize(m) {
    var a = [m[0], m[1], m[2]];
    var la = Math.hypot(a[0], a[1], a[2]);
    a = [a[0] / la, a[1] / la, a[2] / la];
    var b = [m[3], m[4], m[5]];
    var k = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
    b = [b[0] - k * a[0], b[1] - k * a[1], b[2] - k * a[2]];
    var lb = Math.hypot(b[0], b[1], b[2]);
    b = [b[0] / lb, b[1] / lb, b[2] / lb];
    var c = [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
    return [a[0], a[1], a[2], b[0], b[1], b[2], c[0], c[1], c[2]];
  }

  function toGL(m) {
    return new Float32Array([m[0], m[3], m[6], m[1], m[4], m[7], m[2], m[5], m[8]]);
  }

  // Aceita "-23,55" e "-23.55".
  function num(value, fallback) {
    var n = parseFloat(String(value == null ? '' : value).replace(',', '.'));
    return isFinite(n) ? n : fallback;
  }

  function hexToRgb(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var v = parseInt(h, 16);
    if (h.length !== 6 || isNaN(v)) return [0, 0.443, 0.89];
    return [((v >> 16) & 255) / 255, ((v >> 8) & 255) / 255, (v & 255) / 255];
  }

  function compile(gl, type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      var log = gl.getShaderInfoLog(shader);
      gl.deleteShader(shader);
      throw new Error(log);
    }
    return shader;
  }

  class HaloGlobo extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-globo-stage]');
      this.canvas = this.querySelector('canvas');
      if (!this.stage || !this.canvas || this.started) return;
      this.started = true;

      this.markers = Array.prototype.map.call(this.querySelectorAll('[data-marker]'), function (el) {
        return { el: el, lat: num(el.dataset.lat, 0), lon: num(el.dataset.lon, 0), flip: false };
      });
      this.speed = num(this.dataset.speed, 6);
      // "spin" e não "dir": HTMLElement já tem a propriedade dir (direção do texto).
      this.spin = this.dataset.direction === 'ltr' ? -1 : 1;
      this.exposure = num(this.dataset.exposure, 130) / 100;
      this.rimStrength = num(this.dataset.rimStrength, 45) / 100;
      this.rim = hexToRgb(this.dataset.rim);
      this.M = orient(num(this.dataset.lat, -10), num(this.dataset.lon, -50));
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.size = 0;
      this.visible = false;
      this.raf = 0;
      this.last = 0;
      this.frames = 0;
      this.auto = 1;
      this.drag = null;
      this.vx = 0;
      this.vy = 0;
      this.inertia = false;
      this.tween = null;
      this.hold = false;

      this.frame = this.frame.bind(this);
      this.bindEvents();

      var self = this;
      this.io = new IntersectionObserver(
        function (entries) {
          self.visible = entries[entries.length - 1].isIntersecting;
          if (self.visible) {
            self.init();
            self.last = 0;
            self.kick();
          }
        },
        { rootMargin: '200px 0px' }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (!this.started) return;
      this.started = false;
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      if (this.gl) {
        var lose = this.gl.getExtension('WEBGL_lose_context');
        if (lose) lose.loseContext();
        this.gl = null;
      }
    }

    bindEvents() {
      var self = this;

      this.onDown = function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        self.drag = { id: e.pointerId, x: e.clientX, y: e.clientY, t: performance.now() };
        self.vx = 0;
        self.vy = 0;
        self.inertia = false;
        self.tween = null;
        self.auto = 0;
        try {
          self.stage.setPointerCapture(e.pointerId);
        } catch (err) {}
        self.stage.classList.add('is-dragging');
        self.kick();
      };

      this.onMove = function (e) {
        var drag = self.drag;
        if (!drag || e.pointerId !== drag.id) return;
        var now = performance.now();
        var dx = e.clientX - drag.x;
        var dy = e.clientY - drag.y;
        var dt = Math.max(now - drag.t, 1);
        self.rotateBy(dx, dy);
        // Velocidade em px/ms, limitada para um peteleco forte não girar sem parar.
        self.vx = Math.max(-MAX_FLICK, Math.min(MAX_FLICK, self.vx * 0.6 + (dx / dt) * 0.4));
        self.vy = Math.max(-MAX_FLICK, Math.min(MAX_FLICK, self.vy * 0.6 + (dy / dt) * 0.4));
        drag.x = e.clientX;
        drag.y = e.clientY;
        drag.t = now;
        self.kick();
      };

      this.onUp = function (e) {
        var drag = self.drag;
        if (!drag || e.pointerId !== drag.id) return;
        if (performance.now() - drag.t > 120) {
          self.vx = 0;
          self.vy = 0;
        }
        self.drag = null;
        self.stage.classList.remove('is-dragging');
        self.inertia = !self.reduce && Math.abs(self.vx) + Math.abs(self.vy) > 0.02;
        self.kick();
      };

      // O navegador assumiu o gesto (rolagem vertical no celular): solta o globo sem inércia.
      this.onCancel = function () {
        self.drag = null;
        self.inertia = false;
        self.stage.classList.remove('is-dragging');
        self.kick();
      };

      this.onKey = function (e) {
        var step = self.radiusPx() * 0.15;
        var moves = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] };
        var move = moves[e.key];
        if (!move) return;
        e.preventDefault();
        self.inertia = false;
        self.tween = null;
        self.auto = 0;
        self.rotateBy(move[0], move[1]);
        self.kick();
      };

      this.onVisibility = function () {
        if (!document.hidden) {
          self.last = 0;
          self.kick();
        }
      };

      // No editor de temas: ao selecionar um marcador, o globo gira até ele.
      this.onBlockSelect = function (e) {
        var el = self.querySelector('[data-block-id="' + e.detail.blockId + '"]');
        if (!el || !el.hasAttribute('data-marker')) return;
        self.hold = true;
        self.inertia = false;
        self.tween = {
          from: self.center(),
          to: { lat: num(el.dataset.lat, 0), lon: num(el.dataset.lon, 0) },
          start: performance.now(),
          dur: 900,
        };
        self.kick();
      };

      this.onBlockDeselect = function (e) {
        if (!self.hold || !self.querySelector('[data-block-id="' + e.detail.blockId + '"]')) return;
        self.hold = false;
        self.auto = 0;
        self.kick();
      };

      this.onLost = function (e) {
        e.preventDefault();
        cancelAnimationFrame(self.raf);
        self.raf = 0;
        self.tex = null;
        self.classList.remove('is-ready');
      };

      this.onRestored = function () {
        try {
          self.setupProgram();
          self.resize();
          self.loadTexture();
        } catch (err) {
          self.fail();
        }
      };

      this.stage.addEventListener('pointerdown', this.onDown);
      this.stage.addEventListener('pointermove', this.onMove);
      this.stage.addEventListener('pointerup', this.onUp);
      this.stage.addEventListener('pointercancel', this.onCancel);
      this.stage.addEventListener('keydown', this.onKey);
      document.addEventListener('visibilitychange', this.onVisibility);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    init() {
      if (this.gl || this.failed) return;
      try {
        var options = { alpha: true, premultipliedAlpha: true, antialias: false, depth: false, stencil: false };
        var gl = this.canvas.getContext('webgl', options) || this.canvas.getContext('experimental-webgl', options);
        if (!gl) throw new Error('WebGL indisponível');
        this.gl = gl;
        this.texSize = gl.getParameter(gl.MAX_TEXTURE_SIZE) >= 2048 ? 2048 : 1024;
        this.canvas.addEventListener('webglcontextlost', this.onLost);
        this.canvas.addEventListener('webglcontextrestored', this.onRestored);
        this.setupProgram();
        var self = this;
        this.ro = new ResizeObserver(function () {
          self.resize();
        });
        this.ro.observe(this.stage);
        this.resize();
        this.loadTexture();
      } catch (err) {
        this.fail();
      }
    }

    setupProgram() {
      var gl = this.gl;
      var program;
      this.deriv = !!gl.getExtension('OES_standard_derivatives');
      try {
        program = this.link(fragSource(this.deriv));
      } catch (err) {
        if (!this.deriv) throw err;
        this.deriv = false;
        program = this.link(fragSource(false));
      }
      this.aniso =
        gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
      gl.useProgram(program);

      gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      var pos = gl.getAttribLocation(program, 'a_pos');
      gl.enableVertexAttribArray(pos);
      gl.vertexAttribPointer(pos, 2, gl.FLOAT, false, 0, 0);

      var u = {};
      ['u_tex', 'u_rot', 'u_radius', 'u_aa', 'u_glow', 'u_rim', 'u_rimStrength', 'u_exposure'].forEach(function (name) {
        u[name] = gl.getUniformLocation(program, name);
      });
      this.u = u;
      gl.uniform1i(u.u_tex, 0);
      gl.uniform1f(u.u_radius, RADIUS);
      gl.uniform1f(u.u_glow, GLOW);
      gl.uniform3fv(u.u_rim, this.rim);
      gl.uniform1f(u.u_rimStrength, this.rimStrength);
      gl.uniform1f(u.u_exposure, this.exposure);
    }

    link(fragment) {
      var gl = this.gl;
      var program = gl.createProgram();
      gl.attachShader(program, compile(gl, gl.VERTEX_SHADER, VERT));
      gl.attachShader(program, compile(gl, gl.FRAGMENT_SHADER, fragment));
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(program));
      return program;
    }

    loadTexture() {
      var self = this;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = function () {
        if (!self.gl) return;
        // Redimensiona para potência de 2: permite mipmap e repetição na costura do mapa.
        var w = self.texSize;
        var buffer = document.createElement('canvas');
        buffer.width = w;
        buffer.height = w / 2;
        buffer.getContext('2d').drawImage(img, 0, 0, w, w / 2);
        self.upload(buffer);
        buffer.width = 0;
        buffer.height = 0;
        self.classList.add('is-ready');
        self.kick();
      };
      img.onerror = function () {
        self.fail();
      };
      img.src = this.dataset.texture;
    }

    upload(source) {
      var gl = this.gl;
      var tex = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, source);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      if (this.deriv) {
        gl.generateMipmap(gl.TEXTURE_2D);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
        if (this.aniso) {
          var max = gl.getParameter(this.aniso.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
          gl.texParameterf(gl.TEXTURE_2D, this.aniso.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(4, max));
        }
      } else {
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      }
      this.tex = tex;
    }

    resize() {
      var size = this.stage.clientWidth;
      if (!size || !this.gl) return;
      var px = Math.round(size * Math.min(window.devicePixelRatio || 1, 2));
      if (px !== this.canvas.width) {
        this.canvas.width = px;
        this.canvas.height = px;
      }
      this.size = size;
      this.gl.viewport(0, 0, px, px);
      this.gl.uniform1f(this.u.u_aa, 3 / (px * RADIUS));
      this.kick();
    }

    radiusPx() {
      return (this.size || this.stage.clientWidth || 1) * 0.5 * RADIUS;
    }

    // Arrastar o equivalente a um diâmetro gira o globo 180 graus.
    rotateBy(dx, dy) {
      var k = Math.PI / (2 * this.radiusPx());
      this.M = mul(mul(this.M, rotX(-dy * k)), rotY(-dx * k));
    }

    center() {
      var m = this.M;
      return { lat: Math.asin(Math.max(-1, Math.min(1, m[5]))) / DEG, lon: Math.atan2(m[2], m[8]) / DEG };
    }

    kick() {
      if (!this.raf && this.visible && this.tex && this.gl) {
        this.raf = requestAnimationFrame(this.frame);
      }
    }

    frame(t) {
      this.raf = 0;
      var dt = this.last ? Math.min(t - this.last, 64) : 16;
      this.last = t;
      var moving = false;

      if (this.tween) {
        var tw = this.tween;
        var p = Math.min(1, (t - tw.start) / tw.dur);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        var dLon = ((((tw.to.lon - tw.from.lon) % 360) + 540) % 360) - 180;
        this.M = orient(tw.from.lat + (tw.to.lat - tw.from.lat) * e, tw.from.lon + dLon * e);
        if (p >= 1) this.tween = null;
        moving = true;
      } else if (this.drag) {
        moving = true;
      } else if (this.inertia) {
        this.rotateBy(this.vx * dt, this.vy * dt);
        var decay = Math.exp(-dt / 280);
        this.vx *= decay;
        this.vy *= decay;
        if (Math.abs(this.vx) + Math.abs(this.vy) < 0.004) this.inertia = false;
        moving = true;
      } else if (this.speed > 0 && !this.reduce && !this.hold) {
        this.auto = Math.min(1, this.auto + dt / 1500);
        // Gira em torno do eixo da Terra (pré-multiplicação no espaço do globo): a latitude do centro fica fixa.
        this.M = mul(rotY(this.spin * this.speed * DEG * (dt / 1000) * this.auto), this.M);
        moving = true;
      }

      this.frames += 1;
      if (this.frames % 120 === 0) this.M = orthonormalize(this.M);

      this.render();
      this.placeMarkers();

      if (moving && this.visible && !document.hidden) {
        this.raf = requestAnimationFrame(this.frame);
      } else {
        this.last = 0;
      }
    }

    render() {
      var gl = this.gl;
      if (!gl || !this.tex) return;
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.uniformMatrix3fv(this.u.u_rot, false, toGL(this.M));
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }

    placeMarkers() {
      if (!this.markers.length || !this.size) return;
      var m = this.M;
      var r = this.radiusPx();
      var c = this.size / 2;
      for (var i = 0; i < this.markers.length; i++) {
        var mk = this.markers[i];
        var la = mk.lat * DEG;
        var lo = mk.lon * DEG;
        var gx = Math.cos(la) * Math.sin(lo);
        var gy = Math.sin(la);
        var gz = Math.cos(la) * Math.cos(lo);
        // Ponto do globo de volta para a vista: transposta de M.
        var vx = m[0] * gx + m[3] * gy + m[6] * gz;
        var vy = m[1] * gx + m[4] * gy + m[7] * gz;
        var vz = m[2] * gx + m[5] * gy + m[8] * gz;
        var x = c + vx * r;
        var y = c - vy * r;
        var opacity = Math.min(1, Math.max(0, (vz - 0.08) / 0.22));
        mk.el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
        mk.el.style.opacity = opacity.toFixed(3);
        mk.el.style.visibility = opacity > 0 ? 'visible' : 'hidden';
        var flip = x > this.size * 0.62;
        if (flip !== mk.flip) {
          mk.flip = flip;
          mk.el.classList.toggle('is-flipped', flip);
        }
      }
    }

    fail() {
      this.failed = true;
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.classList.remove('is-ready');
      this.classList.add('is-fallback');
    }
  }

  customElements.define('halo-globo', HaloGlobo);
})();
